import { motion } from "framer-motion";
import { SERVICES } from "@/constants/testIds";

const services = [
  { slug: "custom-design", title: "Custom Design", body: "From sketch to finished heirloom." },
  { slug: "jewellery-repair", title: "Jewellery Repair", body: "Restoration of chains, clasps & prongs." },
  { slug: "cleaning", title: "Jewellery Cleaning", body: "Ultrasonic & steam, complimentary." },
  { slug: "ring-sizing", title: "Ring Sizing", body: "Precise resizing without weakening the shank." },
  { slug: "stone-replacement", title: "Stone Replacement", body: "Matched diamonds & coloured stones." },
  { slug: "appraisals", title: "Appraisals", body: "Certified valuations for insurance." },
  { slug: "watch-battery", title: "Watch Battery", body: "Same-day service for most calibres." },
  { slug: "engraving", title: "Engraving", body: "Hand-cut and machine engraving." },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid={SERVICES.section}
      className="relative bg-[#1C1C1A] text-[#F7F5F2] px-6 md:px-10 py-28 md:py-40"
    >
      <div className="flex items-end justify-between border-b border-[#F7F5F2]/15 pb-8 mb-14">
        <div>
          <p className="text-[10px] uppercase tracking-[0.32em] font-sans text-[#E5D5C1]/80 mb-4">
            Ch. 05 — Services
          </p>
          <h2 className="font-serif font-light leading-[0.95] text-5xl md:text-7xl lg:text-8xl tracking-[-0.02em]">
            Goldsmith
            <br />
            <span className="italic text-[#E5D5C1]">in-house.</span>
          </h2>
        </div>
        <p className="hidden md:block font-sans text-sm max-w-xs text-[#F7F5F2]/70">
          Repairs are performed in-house by the same hands that make our
          collections.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 border-t border-l border-[#F7F5F2]/15">
        {services.map((s, i) => (
          <motion.div
            key={s.slug}
            data-testid={SERVICES.item(s.slug)}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{
              duration: 0.7,
              delay: (i % 4) * 0.06,
              ease: [0.16, 1, 0.3, 1],
            }}
            className="group relative border-b border-r border-[#F7F5F2]/15 p-6 md:p-8 min-h-[220px] flex flex-col justify-between overflow-hidden cursor-default"
          >
            <span className="text-[10px] uppercase tracking-[0.3em] font-sans text-[#E5D5C1]/70">
              {String(i + 1).padStart(2, "0")}
            </span>
            <div>
              <h3 className="font-serif text-2xl md:text-3xl leading-tight">
                {s.title}
              </h3>
              <p className="mt-3 text-sm font-sans text-[#F7F5F2]/70 max-w-[240px]">
                {s.body}
              </p>
            </div>
            <span className="absolute right-6 bottom-6 opacity-0 group-hover:opacity-100 translate-x-2 group-hover:translate-x-0 transition-all duration-500 text-[#E5D5C1]">
              →
            </span>
            <span className="absolute inset-x-0 bottom-0 h-0 bg-[#E5D5C1]/10 group-hover:h-full transition-all duration-700 -z-0" />
          </motion.div>
        ))}
      </div>
    </section>
  );
}
